var handler = null

export function setMessageHandler (fn) {
  handler = fn
}

export function showMessage (payload) {
  if (!handler) return
  handler(payload)
}

